import I18n from 'lib/i18n'
import React from 'react'
import { useActions, useValues } from 'kea'

import Checkbox from 'lib/forms/checkbox-svg'

import filtersLogic from '~/scenes/search/filters-page/logic'

export default function Flags () {
  const { unsavedFilter } = useValues(filtersLogic)
  const { updateUnsavedFilter } = useActions(filtersLogic)

  const selectedFlags = {}
  unsavedFilter.flags.split(',').forEach(keyword => {
    selectedFlags[keyword] = true
  })

  function toggleFlag (flag) {
    let flags = unsavedFilter.flags.split(',').filter(v => v)
    if (flags.includes(flag)) {
      flags = flags.filter(v => v !== flag)
    } else {
      flags.push(flag)
    }

    updateUnsavedFilter({ flags: flags.join(',') })
  }

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('react.search.all_filters.verifications.title')}</div>
      <div className='checkbox-list'>
        <Checkbox checked={!!selectedFlags['verified']} onChange={() => toggleFlag('verified')}>
          {I18n.t('react.search.all_filters.verifications.verified')}
        </Checkbox>
        <Checkbox checked={!!selectedFlags['fast']} onChange={() => toggleFlag('fast')}>
          {I18n.t('react.search.all_filters.verifications.fast')}
        </Checkbox>
        <Checkbox checked={!!selectedFlags['reviews']} onChange={() => toggleFlag('reviews')}>
          {I18n.t('react.search.all_filters.verifications.reviews')}
        </Checkbox>
      </div>
    </div>
  )
}
